"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const ModalMenu_1 = __importDefault(require("../../../../components/modal/ModalMenu"));
const constants_1 = require("../../../../constants");
const Home_1 = __importDefault(require("../../../../networking/apis/Home"));
const helpler_1 = require("../../../../utils/helpler");
const scale_1 = require("../../../../utils/scale");
const ItemArticles_1 = __importDefault(require("../../../HomeScreen/components/ItemArticles"));
const styles_1 = __importDefault(require("../styles"));
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const skeletons_1 = require("../../../../components/skeletons");
const HashTagArticle = (props) => {
    const { type, hashtag } = props?.route?.params || props;
    const [visibleMenu, setVisibleMenu] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [reloadPage, setReloadPage] = (0, react_1.useState)(false);
    const [dataCallApi, setDataCallApi] = (0, react_1.useState)([]);
    const [listData, setListData] = (0, react_1.useState)([]);
    const refIsNoMore = (0, react_1.useRef)(false);
    const refCurrentPage = (0, react_1.useRef)(1);
    const isFocused = (0, native_1.useIsFocused)();
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        new react_native_1.NativeEventEmitter().emit(constants_1.listenerEvents.TOTAL_HASHTAG_DETAIL, dataCallApi?.uses || 0);
    }, [dataCallApi]));
    // useFocusEffect(
    // 	React.useCallback(() => {
    // 		console.log('1111111', hashtag,type)
    // 		// Thực hiện các hành động cụ thể khi màn hình hoặc phần tử nhận focus
    // 		reloadScreen()
    // 	}, []),
    // )
    (0, react_1.useEffect)(() => {
        if (isFocused) {
            reloadScreen();
        }
    }, [isFocused]);
    const displayTweet = (data) => {
        let list = [...listData];
        list = list.filter((item) => item?.article_id != data);
        setListData(list);
    };
    (0, react_1.useEffect)(() => {
        if (listData?.length > 0) {
            callApiHashTagArticle(1, true);
        }
    }, [hashtag]);
    const callApiHashTagArticle = async (page, isReload) => {
        if (refIsNoMore.current)
            return;
        await Home_1.default.HashTagArticle({ page, type, hashtag })
            .then((response) => {
            refCurrentPage.current = refCurrentPage.current + 1;
            if (refCurrentPage.current > response.data.articles.last_page) {
                refIsNoMore.current = true;
            }
            isReload && setDataCallApi(response.data);
            if (isReload) {
                setListData(response.data.articles.data);
            }
            else {
                setListData([...listData, ...response.data.articles.data]);
            }
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        })
            .catch((err) => {
            console.log(err);
            setReloadPage(false);
            setLoading(false);
        })
            .finally(() => { });
    };
    const reloadScreen = () => {
        refIsNoMore.current = false;
        refCurrentPage.current = 1;
        setReloadPage(true);
        callApiHashTagArticle(1, true);
    };
    const handleLoadMore = () => {
        callApiHashTagArticle(refCurrentPage.current, false);
    };
    const noData = () => {
        switch (+type) {
            case 1:
                return `このハッシュタグは\n記事では使用されていません`;
            case 2:
                return `このハッシュタグは\n自分史では使用されていません`;
        }
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        loading ? (react_1.default.createElement(skeletons_1.ArticleSkeleton, null)) : (react_1.default.createElement(react_native_1.FlatList, { contentContainerStyle: {
                marginTop: (0, scale_1.scale)(5),
                paddingBottom: (0, scale_1.scale)(50),
            }, showsVerticalScrollIndicator: false, data: listData, renderItem: (item) => (react_1.default.createElement(react_native_1.View, { style: {
                    borderBottomColor: '#DDDDDD',
                    borderBottomWidth: 1,
                    width: '100%',
                    paddingLeft: (0, scale_1.scale)(16),
                } },
                react_1.default.createElement(ItemArticles_1.default, { data: item.item, typeScreen: type, showCreatedAt: true, displayTweet: (data) => {
                        displayTweet(data);
                    } }))), refreshing: reloadPage, onRefresh: reloadScreen, onScroll: ({ nativeEvent }) => {
                if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                    handleLoadMore();
                }
            }, scrollEventThrottle: 400, ListEmptyComponent: react_1.default.createElement(react_native_1.View, { style: {
                    marginTop: (0, scale_1.scale)(32),
                    width: '100%',
                    justifyContent: 'center',
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(16),
                        lineHeight: (0, scale_1.moderateScale)(24),
                        textAlign: 'center',
                        color: '#292A33',
                    } }, noData())) })),
        react_1.default.createElement(ModalMenu_1.default, { visible: visibleMenu, onClose: () => setVisibleMenu(false) })));
};
exports.default = HashTagArticle;
